import { Tooltip } from "@heroui/react";
import { useLanguage } from "@onesolution/hooks";
import type { TranslationsKeys } from "@onesolution/hooks/useLanguage";
import type { OperationStatus } from "@onesolution/serverFn";

export default function ProgressBar(props: { status: OperationStatus[] }) {
	const { t } = useLanguage();

	return (
		<div className="flex rounded-lg h-8 overflow-hidden">
			{props.status.map(({ status, color, count, percent, total }) => (
				<Tooltip
					key={status}
					content={`${t(`status.${status}` as TranslationsKeys)} ${count}/${total} ${percent.toFixed(1)}%`}
				>
					<div
						className="w-full h-full"
						style={{
							width: `${percent}%`,
							backgroundColor: color,
						}}
					/>
				</Tooltip>
			))}
		</div>
	);
}
